// import apiService from './apiService.js';

// export default {
//     getPaginated(url, pageSize, currentPage) {
//         return apiService.getWithQueryAndParams(
//             url,
//             `?pageSize=${pageSize}`,
//             {
//                 page: currentPage
//             }
//         );
//     },
// };

const makeRepository = (HTTP) => ({
    getPaginated(url, pageSize, currentPage) {
        return HTTP.getWithQueryAndParams(
            url,
            `?pageSize=${pageSize}`,
            {
                page: currentPage
            }
        );
    },
});

export default makeRepository;
